export default "__VITE_ASSET__8c0efa5e__"